import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { TextInput, SelectInput } from "../../../../../../common/form";

const SalaryFormula = (props) => {
  const YEAR = 1;
  const MONTHS = 12;
  const WEEKS = 52;
  return (
    <div className="formula">
      <Field
        id="formulaSalaryDenominator"
        name="formulaSalaryDenominator"
        addBlankOption={true}
        component={SelectInput}
        required={true}
        disabled={props.readOnly}
        options={[
          { value: YEAR, key: "common.year", placeHolders: { number: YEAR } },
          {
            value: MONTHS,
            key: "common.months",
            placeHolders: { number: MONTHS },
          },
          {
            value: WEEKS,
            key: "common.weeks",
            placeHolders: { number: WEEKS },
          },
        ]}
        label={
          <FormattedMessage id="clientCoverages.form.formulaSalaryDenominator" />
        }
      />

      <div className="formula-table">
        <div className="row table-header">
          <div className="cell">
            <h5>
              {<FormattedMessage id="clientCoverages.form.formulaPart" />}
            </h5>
          </div>
          <div className="cell">
            <h5>
              {<FormattedMessage id="clientCoverages.form.formulaMultiple" />}
            </h5>
          </div>
        </div>

        <div className="row">
          <div className="cell dollar">
            <Field
              id="formulaPart1"
              name="formulaPart1"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label={
                <FormattedMessage id="clientCoverages.form.formulaPart1" />
              }
            />
          </div>
          <div className="cell">
            <Field
              id="formulaMultiple1"
              name="formulaMultiple1"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label=" x "
            />
          </div>
        </div>

        <div className="row">
          <div className="cell dollar">
            <Field
              id="formulaPart2"
              name="formulaPart2"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label={
                <FormattedMessage id="clientCoverages.form.formulaPart2" />
              }
            />
          </div>
          <div className="cell">
            <Field
              id="formulaMultiple2"
              name="formulaMultiple2"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label=" x "
            />
          </div>
        </div>

        <div className="row">
          <div className="cell dollar">
            <Field
              id="formulaPart3"
              name="formulaPart3"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label={
                <FormattedMessage id="clientCoverages.form.formulaPart3" />
              }
            />
          </div>
          <div className="cell">
            <Field
              id="formulaMultiple3"
              name="formulaMultiple3"
              component={TextInput}
              type="absNumber"
              readOnly={props.readOnly}
              label=" x "
            />
          </div>
        </div>
      </div>
      <div className="dollar plus">
        <Field
          id="formulaRoundedNumber"
          name="formulaRoundedNumber"
          addBlankOption={true}
          component={SelectInput}
          required={true}
          disabled={props.readOnly}
          options={[
            { value: 1, text: "1" },
            { value: 10, text: "10" },
            { value: 100, text: "100" },
            { value: 1000, text: "1000" },
          ]}
          label={
            <FormattedMessage id="clientCoverages.form.formulaRoundedNumber" />
          }
        />
      </div>

      <div className="dollar">
        <Field
          id="formulaMspa"
          name="formulaMspa"
          component={TextInput}
          type="absNumber"
          readOnly={props.readOnly}
          label={<FormattedMessage id="clientCoverages.form.formulaMspa" />}
        />
      </div>

      <div className="dollar">
        <Field
          id="formulaMaximum"
          name="formulaMaximum"
          readOnly={props.readOnly}
          component={TextInput}
          type="absNumber"
          label={<FormattedMessage id="clientCoverages.form.formulaMaximum" />}
        />
      </div>

      <div className="dollar">
        <Field
          id="invoicedClientRate"
          name="invoicedClientRate"
          component={TextInput}
          type="absNumber"
          readOnly={props.readOnly}
          label={
            <FormattedMessage
              id={`clientCoverages.form.invoicedClientRate.${props.ratePeriodType}`}
            />
          }
        />
      </div>

      <div className="dollar">
        <Field
          id="clientRate"
          name="clientRate"
          component={TextInput}
          type="absNumber"
          readOnly={props.readOnly}
          label={
            <FormattedMessage
              id={`clientCoverages.form.clientRate.${props.ratePeriodType}`}
            />
          }
          onBlur={props.onChangeClientRate.bind(null, "clientRate")}
        />
      </div>

      <div className="dollar">
        <Field
          id="providerRate"
          name="providerRate"
          component={TextInput}
          type="absNumber"
          readOnly="readonly"
          label={
            <FormattedMessage
              id={`clientCoverages.form.providerRate.${props.ratePeriodType}`}
            />
          }
        />
      </div>
    </div>
  );
};

SalaryFormula.propTypes = {
  languageCode: PropTypes.string,
  onChangeClientRate: PropTypes.func,
  ratePeriodType: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default SalaryFormula;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/formulas/SalaryFormula.js